import Icon from 'atoms/icon';
import { getCardIcon } from 'util';

export default function PaymentSection({ payment }) {
  if (!payment) return null;
  if (payment.includes('Cash') || payment.includes('Other')) {
    return <p className="f12">{payment}</p>;
  }

  const [brand, last4] = payment.split('-');

  return (
    <div className="flex-row">
      <Icon name={getCardIcon(brand)} />
      <p className="ml-10 f12">{`**** ${last4}`}</p>
    </div>
  );
}
